<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="order-query-form-box">
				<label for="start-date">用户类型：</label>
				<span class="order-query-form-input">
					<el-select v-model="orderForm.userType" placeholder="请选择" class="stSetSelect">
						<el-option
						v-for="item in userTypeList"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
				</span>
			</div>
			
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="data-table-box">
			<common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
				:loading="loading"
				:showPage="togglePage"
				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr" 
				@selectionChange="selectionChange" 
				@currentChange="currentChange"
				@sizeChange="sizeChange">
				<template slot="fieldValue" slot-scope="scope">
                    <span>{{scope.row.rule.fieldValue}}</span>
                </template>
				<template slot="startTime" slot-scope="scope">
                    <span>{{scope.row.startTime?scope.row.startTime:'无期限'}}</span>
                </template>
                <template slot="endTime" slot-scope="scope">
                    <span>{{scope.row.endTime?scope.row.endTime:'无期限'}}</span>
                </template>

			</common-table>
			
		</div>
        <st-dialog title="添加优惠券"  :toggleStDialog="toggleStDialog" @closeDialog="closeDialogForm" @saveDialog="saveDialogForm" :setScrollTop="true">
			<div class="st-dialog-content" >
				<ul class="st-dialog-form clearfix">
                     <li>
						<div class="st-dialog-item-title"><i>*</i>标题：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.title"></div>
					</li>
                    <li>
						<div class="st-dialog-item-title"><i>*</i>发放方式：</div>
						<span class="order-query-form-input">
							<el-select v-model="vehicleForm.distributeWayDesc" placeholder="请选择" @change="changeDistributeWay" class="stSetSelect" >
								<el-option
								v-for="(item,index) in  distributeWayList"
								:key="item.value"
								:label="item.value"
								:value="index">
								</el-option>
							</el-select>
						</span>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>优惠券类型：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.genreDesc" disabled="true"></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>用户类型：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.userTypeDesc" disabled="true"></div>
					</li>
					<li>
						<div class="st-dialog-item-title"><i>*</i>发放数量：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.distributeQuantity" @keyup="changeInput($event,'distributeQuantity')" ></div>
					</li>
                    
                    <li>
						<div class="st-dialog-item-title"><i>*</i>优惠金额：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.rule.fieldValue" @keyup="changeRuleInput($event,'rule.fieldValue')" ></div>
					</li>
					<li>
						<div class="st-dialog-item-title">开始时间：</div>
						<div class="st-dialog-item-input">
                            <el-date-picker
                                v-model="vehicleForm.startTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                class="setTimePicker"
                                value-format="yyyy-MM-dd HH:mm:ss"

                                >
                            </el-date-picker>
                        </div>
					</li>
                    <li>
						<div class="st-dialog-item-title">结束时间：</div>
						<div class="st-dialog-item-input">
                            <el-date-picker
                                v-model="vehicleForm.endTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                class="setTimePicker"
                                value-format="yyyy-MM-dd HH:mm:ss"
								:picker-options="pickerOptions"
                            >
                            </el-date-picker>
                        </div>
					</li>
                    <li>
						<div class="st-dialog-item-title">每人可领取次数：</div>
						<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.perLimit"  @keyup="changeInput($event,'perLimit')"></div>
					</li>
                    <li v-if="showgenre == 'FULLCUTCOUPON'">
                    	<div class="st-dialog-item-title"><i>*</i>满减起步金额：</div>
                    	<div class="st-dialog-item-input"><input type="text" v-model="vehicleForm.rule.startAmount" @keyup="changeAmountInput($event,'rule.startAmount')" ></div>
                    </li>
                    <li style="height:48px">
                        
                    </li>
                    <li style="width:100%">
						<div class="st-dialog-item-title">摘要(优惠券说明)：</div>
						<div class="st-dialog-item-input"><input type="text" style="width:100% " v-model="vehicleForm.summary"></div>
					</li>
                    
				</ul>
			</div>
		</st-dialog>
	</div>
</template>
<script>
import stDialog from '../../components/StDialog'
export default {
	name: 'CouponQuery',
	computed:{
		
	},
	components: {stDialog},
	data(){
		return{
			pickerOptions:{
				disabledDate:(time)=> {
					return time.getTime() < new Date(this.vehicleForm.startTime).getTime() ;
				}
			},
			showgenre:null,//展示满减起步价
			tableColumns:[
				{
					key: '',
					title: '操作',
					align:'center',
					operate:true,
					width:'80',
					setBtns:(row,index)=>{
						return [
							{
								label:'删除',
								handler: (row,index) => this.delCoupons(row.id)
							}
						]
					}
				},{
                    width:'80',
                    align:"center",
					key:'userTypeDesc',
					title:'用户类型',
				},{
					width:'100',
					title:'优惠券类型',
					key:'genreDesc',
				},{
					width:'80',
                    align:"center",
					title:'优惠券金额',
                    slotName:'fieldValue',
                    slot:true
				},{
                    width:'80',
                    align:"center",
					key:'stateDesc',
					title:'优惠券状态',
				},{
                    width:'80',
                    align:"center",
					key:'distributeQuantity',
                    title:'发放数量',
				},{
                    width:'80',
                    align:"center",
					title:'限领数量',
					key:'perLimit',
				},{
					key:'title',
					title:'标题',
				},{
					title:'发放方式',
					key:'distributeWayDesc',
				},{
                    slotName:'startTime',
                    slot:true,
					title:'优惠券开始时间',
				},{
					title:'优惠券结束时间',
                    slotName:'endTime',
                    slot:true
				},{
					key:'summary',
					title:'摘要',
				}
			],
			loading:false,
			bottomHandleArr:[
				{
					label: '添加',
					type: 'success',
					handler: () => this.addCoupons()
				}
            ],
            genreList:[],
			pageConfig: {
				total: 0,
				pageSize: 100,
				currentPage: 1,
			},
			dataList:[], //订单列表
			dataTotal: {},
			orderForm:{
				userType:''
            },
            vehicleForm:{
                perLimit:1,
                rule:{
                    fieldValue:''
                }
            },
            toggleStDialog:false,//控制弹窗
            
			togglePage:false, //是否显示分页
			selDriverId:null, //选中的司机
			selectedList:[],// 选中的列表
			driverList:[],// 司机列表
			toggleStDialog:false,// 弹窗
			userTypeList:[{
					value: '',
					label: '全部'
				},{
					value: 1,
					label: '货主'
				},{
					value: 2,
					label: '司机'
            }],
            userTypeList2:[{
					value: 1,
					label: '货主'
				},{
					value: 2,
					label: '司机'
            }],
            checkFrom:{
                distributeQuantity:'请填写发放数量',
                distributeWay:'请选择发放方式',
                genre:'请选择优惠券类型',
                // perLimit:'请填写每人领取数量',
                // summary:'请填写摘要',
                title:'请填写标题'
				
			},
			
            distributeWayList:[]
		}
	},
	created() {
		
		this.getBase()
	},
	methods: {
        
		sizeChange(size) {
			this.pageConfig.currentPage = 1
			this.pageConfig.pageSize = size
			this.searchList()
		},
		currentChange(currentPage) {
			this.pageConfig.currentPage = currentPage
			this.searchList()
      	},
		cellClass(row){     
			if (row.columnIndex === 0) {           
				return 'disabledCheck'     
			} 
		},
		selectionChange(val){
			this.selectedList=val; 
		},
		searchList(flag){
			let pages={};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			if(flag) pages.current = 1;
			let orderForm=this.orderForm;
			Object.assign(orderForm,pages)
            this.loading=true;
           
			this.$server.financial.queryAllCouponActivity(orderForm, (res) => {
                this.loading=false;
				if(res.code==0){
					this.dataList=res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					if(res.data.total>0){
						this.togglePage=true;
					}
				}

			})
        },
        addCoupons(){
            this.toggleStDialog=true;
			this.vehicleForm={ 
				perLimit:1,
                startTime:null,
                endTime:null,
                rule:{
                    fieldValue:''
                }
            };
        },
        getBase(){
            this.$server.financial.getBase({}, (res) => {
                if(res.code==0){
                    this.distributeWayList=res.data.allType;
                }
			})
        },
        closeDialogForm(){
			this.toggleStDialog=false;
		},
		delCoupons(id){
			this.$server.financial.deleteCoupon(id,(res)=>{
				this.$message({
					message: '删除成功',
					center: true
				});
				this.searchList()
			})
		},
        saveDialogForm(){
			for(var key in this.checkFrom){
				if(!this.vehicleForm[key]){
					return	this.$message({
						message:  this.checkFrom[key],
						center: true,
						type: 'warning'
					});
				}
			}
            let data=JSON.parse(JSON.stringify(this.vehicleForm));
            if(data.startTime){
                data.startTime=new Date(data.startTime).getTime()
            }
            if(data.endTime){
                data.endTime=new Date(data.endTime).getTime()
			}
			if(data.perLimit===''){
				data.perLimit=null
			}
			this.$server.financial.addCouponActivity(data,(res)=>{
				if(res.code==0){
					this.$message({
						message: '添加成功',
						center: true
					});
                    this.searchList(true)
				}else{
					this.$message({
						message: res.message,
						center: true
					});
				}
			})
			this.toggleStDialog=false;
		},
		changeDistributeWay(index){
			let item=this.distributeWayList[index];
			Object.assign(this.vehicleForm,item)
			this.showgenre = item.genre
			console.log(item)
		},
		changeInput(e,attr){
			let inputValue=e.target.value 
			let reg=/^\d*$/
			this.vehicleForm[attr]=inputValue.replace(/[^\d]/g,'')
		}, 
		changeRuleInput(e,attr){
			let inputValue=e.target.value 
			this.vehicleForm.rule.fieldValue=Number(this.$util.numDotCovt(inputValue,2));
		},
		
		changeAmountInput(e,attr){
			let inputValue=e.target.value
			this.vehicleForm.rule.startAmount=Number(this.$util.numDotCovt(inputValue,2));
		},
		// 导出
		exportTable(){
			let that = this;
			if (this.dataList.length < 1) {
			that.$toast.stMessage('暂无订单', true)
			return;
			}
			let pages = {};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			const sendData = {
				...this.orderForm,
				exportColumnFiledNames:  this.tableColumns.map((item) => {
						return item.slotName || item.key
					}).filter(item => {
						return item && item.trim()
					})
			}
			sendData.beginTime = sendData.beginTime ? new Date(sendData.beginTime).getTime() : ''
			sendData.endTime = sendData.endTime ? new Date(sendData.endTime).getTime() : ''
			Object.assign(sendData, pages)
			this.$server.common.exportTable('/finance/account-page-export', sendData, (res) => {
			console.log('导出成功')
			})
			
		},
	},
	mounted() {
		
	}
}

</script>
<style scoped>

.driver-account {
  width: 100%;
  height: auto;
}
.data-table-box {
	/* display: flex;
	justify-content: center;
	align-items: center; */
    height: auto;
    background: #FFF;
    padding: 8px;
	box-sizing: border-box;
	text-align: center;
}	
.data-table-warp{
	/* display: inline-block; */
	width: auto;
	margin: 0 auto;
}
.data-table{
	margin-bottom: 8px;
	/* border: 1px solid #ccc; */
}
.query-setting-box-left{
    flex-grow: 0;
}


.st-dialog-content{
	padding: 0 32px;
}
.st-dialog-form{
	width: 406px;
}
.st-dialog-form li {
	width: 156px;
	padding: 13px 0;
}
.st-dialog-form li:nth-child(even){
	float: right;
}
.st-dialog-form li:nth-child(odd){
	float: left;
}
.st-dialog-form .st-dialog-item-title{
	height: 20px;
	line-height: 20px;
}
.st-dialog-form .st-dialog-item-title i{
	color: #FF5B3E;
}
.st-dialog-form .st-dialog-item-input input{ 
	width: 156px;
	height: 30px;
	text-indent: 8px;
	border-radius: 2px;
	border: 1px solid #DCDCDC;
	box-sizing: border-box;
    position:relative  ;
}
.setTimePicker{
	width: 156px;
}
.setTimePicker /deep/.el-input__inner {
	padding-left: 4px;
    padding-right: 0;
    height: 30px ;  
}
.setTimePicker /deep/ .el-input__prefix{
    display: none;
}
</style>
